import React, { useEffect, useState } from "react";
import "./NotificationsPopup.css";
import { useTranslation } from "react-i18next";
import { fetchNotifications, readAllNotifications } from "../../store/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { notificationsSelector } from "../../store/selectors";
import bellIcon from "../../assets/bell.svg";
import { ReactComponent as BellIcon } from "../../assets/bell.svg";
import Avatar from "../Avatar/Avatar";
import { useNavigate } from "react-router";
import useIsMobile from "../../hooks/useIsMobile";

const NotificationsPopup = ({}) => {
  const notificationsArray = useSelector(notificationsSelector);
  const [showNotifications, setShowNotifications] = useState(false);
  const [isInitiallyChanged, setIsInitiallyChanged] = useState(false);
  const [areNewNotifications, setAreNewNotifications] = useState(false);
  const [hoveredNotificationId, setHoveredNotificationId] = useState(false);
  const [isHovered, setIsHovered] = useState("");
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!showNotifications && !isInitiallyChanged) {
      dispatch(fetchNotifications()).then((res) => {
        if (!res.error) {
          if (res.payload.find((notification) => !notification.read)) {
            setAreNewNotifications(true);
          } else {
            setAreNewNotifications(false);
          }
        }
      });
    }
    if (showNotifications) {
      dispatch(fetchNotifications()).then((res) => {
        setIsInitiallyChanged(true);
        if (!res.error) {
          if (res.payload.find((notification) => !notification.read)) {
            setAreNewNotifications(true);
          } else {
            setAreNewNotifications(false);
          }
        }
      });
    }

    if (!showNotifications && isInitiallyChanged) {
      dispatch(readAllNotifications());
    }
  }, [showNotifications]);

  useEffect(() => {
    const handleClick = (e) => {
      if (
        !e.target.closest(".notification-btn") &&
        !e.target.closest(".notifications-popup-container") &&
        !e.target.closest(".notifications-settings-text") &&
        !e.target.closest(".notifications-settings-button")
      ) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const getNotificationText = (notification) => {
    if (notification.type === "ACCESS_GRANTED") {
      const author = notification.actor;
      return `${author.firstName} ${author.lastName} предоставил вам доступ к ${
        notification.payload.version ? "версии" : "проекту"
      } "${
        notification.payload.version
          ? notification.payload.version.version
          : notification.payload.project.title
      }"`;
    }

    if (notification.type === "VERSION_READY") {
      const author = notification.actor;
      return `${author.firstName} ${author.lastName} добавил новое видео "${notification.payload.video.version}" в проект "${notification.payload.project.title}"`;
    }

    if (notification.type === "ORGANIZATION_RETENTION_WARNING") {
      return `Через ${notification.payload.daysLeft} дней данные рабочего пространства "${notification.payload.organization.title}" будут удалены. Продлите тариф, чтобы сохранить их.`;
    }

    if (notification.type === "ROOT_COMMENT_CREATED") {
      const author = notification.actor;
      return `${author.firstName} ${author.lastName} оставил(а) комментарий к видео `;
    }

    if (notification.type === "COMMENT_REPLIED") {
      const author = notification.actor;
      return `${author.firstName} ${author.lastName} ответил на ваш комментарий к видео "${notification.payload.video.version}""`;
    }

    if (notification.type === "SUBSCRIPTION_STATUS_CHANGED") {
      const author = notification.actor;
      return `Тариф "${notification.payload.subscription.plan.name}" ${
        notification.payload.subscription.status === "ACTIVE"
          ? "активирован"
          : "больше не действует"
      }`;
    }

    return "Неизвестный тип уведомления";
  };

  const handleClickNotification = (notification, event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(readAllNotifications());
    if (notification.type === "ACCESS_GRANTED") {
      navigate(`/projects/${notification.payload.project.id}`);
    } else if (notification.type === "VERSION_READY") {
      navigate(`/video/${notification.payload.video.id}`);
    } else if (notification.type === "ROOT_COMMENT_CREATED") {
      navigate(`/video/${notification.payload.video.id}`);
    } else if (notification.type === "COMMENT_REPLIED") {
      navigate(`/video/${notification.payload.video.id}`);
    }
  };

  const renderNotification = (notification, isLast) => {
    const author = notification.actor;
    const userEmail = (author && author.email) || "7cut";
    return (
      <div
        onClick={(e) => handleClickNotification(notification, e)}
        className="notification-container"
        style={{
          borderBottom: isLast ? "none" : "1px solid rgba(113, 123, 142, 0.5)",
          backgroundColor:
            notification.id === hoveredNotificationId
              ? "rgba(113, 123, 142, 0.5)"
              : notification.read
                ? "transparent"
                : "rgba(113, 123, 142, 0.5)",
        }}
        onMouseEnter={() => setHoveredNotificationId(notification.id)}
        onMouseLeave={() => setHoveredNotificationId(null)}
      >
        <div style={{ flex: 1 }}>
          <Avatar user={author} name={userEmail} size={36} />
        </div>
        <div
          style={{
            flex: 7,
            display: "flex",
            alignItems: "flex-start",
            paddingLeft: 10,
            paddingRight: 10,
          }}
        >
          <span
            style={{
              fontSize: 14,
              fontWeight: 500,
              textAlign: "left",
              width: "100%",
            }}
          >
            {getNotificationText(notification)}{" "}
            {notification.type === "ROOT_COMMENT_CREATED" && (
              <span style={{ color: "#9A6AFF" }}>
                {notification.payload.video.version}
              </span>
            )}
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <button
        className="notification-btn"
        onClick={() => setShowNotifications((v) => !v)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <BellIcon
          style={{
            // transform: "scale(3.7)",
            color: isHovered ? "white" : "#717B8E",
          }}
          width={24}
          height={24}
        />
        {/* <img src={bellIcon} alt="notifications" width={24} height={24} /> */}
        {areNewNotifications && (
          <div
            style={{
              width: 4,
              height: 4,
              borderRadius: 50,
              backgroundColor: "#9A6AFF",
              border: "1.5px solid #9A6AFF",
              position: "absolute",
              right: 3,
              top: 3,
            }}
          />
        )}
      </button>
      {showNotifications && (
        <div
          className={
            isMobile
              ? "notifications-popup-container-mobile"
              : "notifications-popup-container"
          }
        >
          <div style={{ width: "100%", height: "100%", position: "relative" }}>
            <div
              onClick={() => {
                navigate("/notifications");
              }}
              className="notifications-settings-button"
              style={{
                width: "114%",
                height: 50,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                backgroundColor: "#1f242e",
                paddingRight: 24,
                boxSizing: "border-box",
                cursor: "pointer",
                top: 0,
                right: 0,
                left: 0,
              }}
            >
              <span className="notifications-settings-text">
                Настройка уведомлений
              </span>
            </div>
            {!notificationsArray.length && (
              <div className="notifications-dummy">Нет новых уведомлений</div>
            )}
            {!!notificationsArray.length && (
              <>
                {notificationsArray.map((notification, index) =>
                  renderNotification(
                    notification,
                    index === notificationsArray.length - 1
                  )
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationsPopup;
